import "./NewsSourceSelectorComponent.scss";
import template from "./NewsSourceSelectorComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {
    allSelected,
    allUnSelected,
    defaultSelection,
    SelectedNewsSources,
    SelectionEntries,
    selectionEntries
} from "./model/SelectedNewsSources";
import {Observable, ReplaySubject} from "rxjs";
import {NewsSource} from "../../types/NewsVendors";
import {ComponentCallback} from "../../../types/AngularJS";
import {identity} from "../../../js/util/UtilFunctions";

export const NewsSourceSelector = "tfNewsSourceSelector";

export function newsSourceSelector(): IComponentOptions {
    return {
        template,
        bindings: {
            selected: "<",
            onChange: "&"
        },
        transclude: true,
        controllerAs: "ctrl",
        controller: NewsSourceSelectorComponentController
    };
}

export class NewsSourceSelectorComponentController implements IOnInit, IOnDestroy {

    /** @input */
    public set selected(selected: SelectedNewsSources | null) {
        if (selected != null) {
            this.selected$.next(selected);
        } else {
            this.selected$.next(defaultSelection());
        }
    }

    private readonly selected$ = new ReplaySubject<SelectedNewsSources>(1);

    /** @output */
    public readonly onChange: ComponentCallback;

    public readonly selections$: Observable<SelectionEntries>;
    public readonly allOn$: Observable<boolean>;

    private readonly toggle$ = new ReplaySubject<NewsSource>(1);
    private readonly toggleAll$ = new ReplaySubject<boolean>(1);
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public constructor() {
        this.selections$ = this.selected$
                               .map(selectionEntries)
                               .publishReplay(1)
                               .refCount();
        this.allOn$ = this.selections$
                          .map((s) => s.map((e) => e.selected).every(identity()))
                          .publishReplay(1)
                          .refCount();
    }

    public $onInit(): void {
        this.toggle$
            .takeUntil(this.destroyed$)
            .withLatestFrom(this.selected$)
            .map(([toggled, selected]) => this.updateSelected(toggled, selected))
            .subscribe((selected) => this.onChange({selected}));

        this.toggleAll$
            .takeUntil(this.destroyed$)
            .withLatestFrom(this.allOn$)
            .map(([_, allOn]) => this.toggleAll(allOn))
            .subscribe((selected) => this.onChange({selected}));
    }

    private updateSelected(toggled: NewsSource, selected: SelectedNewsSources): SelectedNewsSources {
        return {
            ...selected,
            [toggled]: !selected[toggled]
        };
    }

    private toggleAll(allOn: boolean): SelectedNewsSources {
        if (allOn) {
            return allUnSelected();
        } else {
            return allSelected();
        }
    }

    public toggle(source: NewsSource) {
        this.toggle$.next(source);
    }

    public toggleAllSources() {
        this.toggleAll$.next(true);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
